export interface IOnboardingStep {
  label?: string;
  header?: string;
  image?: string;
  selector?: string;
}

export const ONBOARDING_ICON_OPTIONS = [
  { value: "info-circle", label: "Info Circle" },
  { value: "playstation-circle", label: "Question Circle" },
  { value: "alert-triangle", label: "Alert Triangle" },
  { value: "exclamation-circle", label: "Exclamation Circle" },
  { value: "circle-check", label: "Check Circle" },
  { value: "lightning", label: "Lightning" },
  { value: "star", label: "Star" },
  { value: "eye", label: "Eye" },
  { value: "wand", label: "Wand" },
  { value: "bolt", label: "Bolt" },
  { value: "circle-dashed-check", label: "Dashed Check" },
  { value: "scan-eye", label: "Scan Eye" },
  { value: "animated-beacon", label: "Animated: Beacon" },
  { value: "animated-pulse", label: "Animated: Pulse" },
  { value: "animated-ripple", label: "Animated: Ripple" },
  { value: "animated-attention", label: "Animated: Attention" },
  { value: "animated-spin", label: "Animated: Spin" },
  { value: "animated-bounce", label: "Animated: Bounce" }
] as const;

export type OnboardingIconType = (typeof ONBOARDING_ICON_OPTIONS)[number]["value"];

export interface IOnboardingTooltipItem {
  id: string;
  name?: string;
  selector?: string;
  useCssSelector?: boolean;
  label?: string;
  header?: string;
  image?: string;
  steps?: IOnboardingStep[];
  learnMoreUrl?: string;
  position: "top" | "right" | "bottom" | "left";
  triggerType: OnboardingTooltipTriggerType;
  backgroundColor?: string;
  textColor?: string;
  width?: number;
  height?: number;
  icon?: OnboardingIconType;
  iconColor?: string;
  iconSize?: number;
  iconPosition?: OnboardingIconPosition;
  tooltipOffsetX?: number;
  tooltipOffsetY?: number;
  iconOffsetX?: number;
  iconOffsetY?: number;
  isDraft: boolean;
  folderId?: string;
  createdAt: number;
  updatedAt: number;
}

export interface IOnboardingFolder {
  id: string;
  name: string;
  parentId?: string;
  order: number;
}

export type OnboardingTooltipPosition = "top" | "right" | "bottom" | "left";
export type OnboardingTooltipTriggerType = "hover" | "click" | "auto" | "hint" | "always";
export type OnboardingIconPosition =
  | "top-start"
  | "top-center"
  | "top-end"
  | "right-start"
  | "right-center"
  | "right-end"
  | "bottom-start"
  | "bottom-center"
  | "bottom-end"
  | "left-start"
  | "left-center"
  | "left-end";
